import WelcomePage from './WelcomePage';
import './WelcomePage.scss';

export default WelcomePage;
